import Kontrahenci from './Kontrahenci';
export default Kontrahenci;